// Google Analytics utility functions

// Declare gtag function for TypeScript
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag?: (command: string, ...args: any[]) => void;
  }
}

/**
 * Send a page view event to Google Analytics
 * @param path - The page path to track
 */
export const trackPageView = (path: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-X61DWQTYS5', {
      page_path: path,
    });
  }
};

/**
 * Send a custom event to Google Analytics
 * @param eventName - The name of the event
 * @param params - Event parameters
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, params);
  }
};
